import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { CreateActionPlanResponseDTO } from '@/core/dto/action-plan-creation';
import { Service } from '@/infra/services/action-plan';
import { QUERY_KEYS } from '@/utils/query-keys';
import { queryClient } from '@/store/query';
import type { Response } from '@/types';

type ActionPlanStatus = 'TO DO' | 'DOING' | 'DONE';

type ActionPlanOrigin = {
	origin_name: string;
	table_name: string;
	column_id: string;
};

interface CreateActionPlanParams {
	organization_id: string;
	company_id: string;
	workstation_id: string;
	title: string;
	due_date: Date;
	responsible_user_id: string;
	investment_range: number;
	priority: number;
	status: ActionPlanStatus;
	origin: ActionPlanOrigin;
}

export const useCreateActionPlan = () => {
	return useMutation<CreateActionPlanResponseDTO, AxiosError<Response>, CreateActionPlanParams>({
		mutationFn: (params) => Service.create(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_ACTION_PLAN_LIST]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_ACTION_PLAN_CARD_LIST]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_ACTION_PLANS_BY_ORIGIN]);
		}
	});
};
